import { useMutation as r } from "@tanstack/react-query";
import { customInstance as s } from "../../mutator/custom-instance.es.js";
const m = (t, n, i, o) => s({
  url: `/api/guest-bookings/${t}/pricing/diff`,
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  },
  data: n,
  signal: o
}, i), c = (t) => {
  const n = ["diffGuestBookingPricing"], {
    mutation: i,
    request: o
  } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : {
    ...t,
    mutation: {
      ...t.mutation,
      mutationKey: n
    }
  } : {
    mutation: {
      mutationKey: n
    },
    request: void 0
  };
  return {
    mutationFn: (u) => {
      const {
        guestBookingId: e,
        data: a
      } = u ?? {};
      return m(e, a, o);
    },
    ...i
  };
}, k = (t) => {
  const n = c(t);
  return r(n);
};
export {
  m as diffGuestBookingPricing,
  c as getDiffGuestBookingPricingMutationOptions,
  k as useDiffGuestBookingPricing
};
